module.exports = __webpack_public_path__ + "img/nt.9f9168be.jpg";